export default {
  install(Vue) {
    if (window.location.href.indexOf('#') < 0) {
      throw new Error('vue-location: The vue-router mode must be hash');
    } else {
      Vue.prototype.$location = {
        url(val) {
          let full = window.location.hash;
          if (val) {
            let url = '#' + val;
            if (val[0] != '/') {
              let lastIndex = full.lastIndexOf('/');
              url = full.substring(0, lastIndex + 1) + val;
            }
            window.location.replace(url);
            return url.substring(1);
          } else {
            return full.substring(1);
          }
        },
        path() {
          return window.location.hash.split('?')[0].substring(1);
        },
        search(param) {
          let split = window.location.hash.split('?');
          let query = {};
          if (split.length == 2) {
            let paramsArr = split[1].split('&');
            let temp = [];
            for (let i = 0; i < paramsArr.length; i++) {
              temp = paramsArr[i].split('=');
              query[temp[0]] = temp[1];
            }
          }
          if (typeof param == 'object') {
            let replace = '?';
            if (split.length == 2) {
              query = Object.assign(query, param);
            } else {
              query = param;
            }
            for (let key in query) {
              replace += key + '=' + query[key] + '&';
            }
            replace.substring(0, replace.length - 1);
            window.location.replace(split[0] + replace);
          } else {
            return query;
          }
        },
        clear() {
          let split = window.location.hash.split('?');
          if (split.length == 2) {
            window.location.replace(split[0]);
          }
        }
      };
    }
  },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-location/src/location.js
// module id = jbfy
// module chunks = 0